﻿import styled from "styled-components";

export const MaxWidthWrapper = styled.div`
  max-width: ${({ maxWidth }) => maxWidth};
`;
